module.exports = __webpack_public_path__ + "static/media/ic-edit.d7c98f28.svg";